export const selectWithdraw = {
	wallet: (state) => state.withdraw.wallet,
	method: (state) => state.withdraw.method,
	isVisibleAddMethod: (state) => state.withdraw.isVisibleAddMethod,
	isVisibleUpdateAcc: (state) => state.withdraw.isVisibleUpdateAcc,
	isVisibleTaxInfo: (state) => state.withdraw.isVisibleTaxInfo,
	withdrawParams: (state) => state.withdraw.withdrawParams,
};
